export default __webpack_public_path__ + "static/media/list-selected.8c24a1f0.svg";